import PropTypes from 'prop-types'
import styled from 'styled-components'

import Spinner from 'components/Shared/Spinner/Index'

const StyledWrapper = styled.div`
  position: absolute;
  right: 0;
  left: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(255,255,255,0.7);
  z-index: ${props => props.zIndex || '999999'};
`

const StyledSpinner = styled(Spinner)`
  position: absolute;
  top: 45%;
  left: 50%;
  transform: translate(-50%, -50%);
`

const LoadingIndicator = ({ loading = true, small, zIndex }) => {
  const size = small ? 48 : 112

  if (loading) {
    return (
      <StyledWrapper zIndex={zIndex}>
        <StyledSpinner size={size} />
      </StyledWrapper>
    )
  } else {
    return null
  }
}

LoadingIndicator.propTypes = {
  loading: PropTypes.bool,
  small: PropTypes.bool,
  zIndex: PropTypes.number,
}

export default LoadingIndicator
